module.exports = __webpack_public_path__ + "img/paper-recycle.a6cff8f0.svg";